import React from 'react';
import './JobCard.css';
import { IoLocationOutline } from 'react-icons/io5';
import { IoArrowBack } from 'react-icons/io5';
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import { BsBriefcase } from "react-icons/bs";
import jobPlaceholder from '../../assets/images/ftrdClgImgPlaceholder.png'; // Using placeholder as requested

const JobCard = ({ job, onClick, hideTags = false, showApplyButton = false, minimal = false }) => {
  // Destructure with new API fields
  const {
    title,
    companyDetails,
    location,
    salary,
    experienceStart,
    experienceEnd,
    skillsRequired,
    description,
    createdAt,
    jobType,
    recruiter // fallback for logo?
  } = job || {};

  // Helpers
  const getString = (val) => {
    if (typeof val === 'string' || typeof val === 'number') return val;
    if (typeof val === 'object' && val !== null) {
      return val.name || val.title || val.code || val.label || '';
    }
    return '';
  };

  const getSalaryString = () => {
    if (!salary) return 'Not Disclosed';
    // If salary is a raw number like 1500000
    if (typeof salary === 'number') {
      if (salary >= 100000) {
        return `₹ ${(salary / 100000).toFixed(1)} LPA`; // 15.0 LPA
      }
      return `₹ ${salary.toLocaleString()}`;
    }
    return getString(salary);
  };

  const getExperienceString = () => {
    if (experienceStart !== undefined && experienceEnd !== undefined) {
      return `${experienceStart} - ${experienceEnd} Years`;
    }
    return '0-1 Years';
  };

  const getLocationString = () => {
    return location || companyDetails?.city || companyDetails?.state || 'Location';
  };

  // Tags: Combine skills and jobType
  const getTags = () => {
    let tags = [];
    if (jobType) {
        // jobType might be object { name: "Exprienced" } or just string
        tags.push(getString(jobType));
    }
    if (Array.isArray(skillsRequired)) {
        tags = [...tags, ...skillsRequired];
    }
    return tags.length > 0 ? tags : ['Full Time'];
  };

  const getPostedDate = () => {
    if (!createdAt) return 'Just now';
    const date = new Date(createdAt);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    
    if (diffDays === 1) return '1 day ago';
    if (diffDays < 30) return `${diffDays} days ago`;
    return date.toLocaleDateString();
  };
  
  // Logo Logic: Try companyDetails.companyLogo
  // If it's a filename, we might need a base URL, but for now stick to raw or placeholder on error.
  const logoUrl = companyDetails?.companyLogo || recruiter?.profilePictures?.[0]?.img;

  const handleApply = (e) => {
    e.stopPropagation();
    window.open('https://risohire.com', '_blank');
  };

  return (
    <div className={`job-card ${minimal ? 'job-card-minimal' : ''}`} onClick={onClick}>
      <div className="job-card-header">
        <div className="job-card-info">
          <h3 className="job-title">{getString(title) || 'Job Title'}</h3>
          <p className="company-name">{getString(companyDetails?.companyName) || 'Company Name'}</p>
        </div>
        <div className="job-card-logo">
           <img 
             src={logoUrl || jobPlaceholder} 
             alt="Company Logo" 
             onError={(e) => {e.target.onerror = null; e.target.src = jobPlaceholder}}
           />
        </div>
      </div>

      <div className="job-meta-row">
        <div className="meta-item">
            <BsBriefcase className="meta-icon"/>
            <span>{getExperienceString()}</span>
        </div>
        <div className="meta-item">
            <HiOutlineCurrencyRupee className="meta-icon"/>
            <span>{getSalaryString()}</span>
        </div>
         <div className="meta-item">
            <IoLocationOutline className="meta-icon"/>
            <span>{getLocationString()}</span>
        </div>
      </div>

      {!hideTags && (
        <div className="job-tags">
            {getTags().slice(0, 4).map((tag, i) => ( 
            <span key={i} className="job-tag">{getString(tag)}</span>
            ))}
        </div>
      )}

      {/* Description removed in minimal mode? User said "all the listed jobs are in a single card". Usually similar jobs show less info. But let's keep consistent for now unless specified. */}
      {/* Wait, user requirements for right section: "Role title, Company Name, Meta row, Tags". NO description mentioned in right section text request. But also didn't explicitly remove it. I'll hide description if minimal/similar. */} 
      {!minimal && (
          <div className="job-description">
            {getString(description) || "Lorem ipsum dolor sit amet, consectetur adipiscing elit."}
          </div>
      )}

      <div className="job-footer" style={showApplyButton ? { flexDirection: 'column', alignItems: 'flex-start', gap: '12px' } : {}}>
        <span className="posted-date">{getPostedDate()}</span>
        {showApplyButton && (
            <button className="job-apply-btn" onClick={handleApply}>
                APPLY NOW
            </button>
        )}
      </div>
    </div>
  );
};

export default JobCard;
